import React, { useState } from "react";
import { Button, Dropdown, DropdownItem, DropdownMenu } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { far } from "@fortawesome/pro-regular-svg-icons";
import useI18n from "../hooks/useI18n";
import { defineMessages, injectIntl } from "react-intl";
import PropTypes from "prop-types";

const messages = defineMessages({
    fi: {
        id: "Suomi",
        defaultMessage: "Suomi"
    },
    se: {
        id: "Svenska",
        defaultMessage: "Svenska"
    },
    en: {
        id: "English",
        defaultMessage: "English"
    },
    no: {
        id: "Norsk",
        defaultMessage: "Norsk"
    }
});

const LocaleDropdownSelector = (props) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const { getLocale, getLanguages } = useI18n();
    const userLocale = getLocale();

    const lng = props.intl.formatMessage;

    /**
     * Switch the language and reload the page.
     * @param {string} locale
     */
    const switchLang = (locale) => {
        localStorage.setItem('locale', locale);
        window.location.reload();
    }

    const chevronElement = showDropdown
        ? (<FontAwesomeIcon icon={far.faChevronUp} />)
        : (<FontAwesomeIcon icon={far.faChevronDown} />);

    return (
        <Dropdown show={showDropdown} className="login-language language-dropdown">
            <Button onClick={() => setShowDropdown(!showDropdown)} className="login-language btn-login-language">
                {!props.hideChevron && chevronElement}
                &nbsp;
                {lng(messages[userLocale])}
            </Button>
            <DropdownMenu className="login-language">
                {getLanguages().map(language => (
                    userLocale !== language && <DropdownItem
                        key={`language-dropdown-item-${language}`}
                        className="login-language btn btn-language-dropdown"
                        onClick={() => switchLang(language)}>
                        {lng(messages[language])}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </Dropdown>
    )
}

LocaleDropdownSelector.propTypes = {
    intl: PropTypes.object.isRequired,
    hideChevron: PropTypes.bool
}

export default injectIntl(LocaleDropdownSelector);
